export default __webpack_public_path__ + "static/media/2.61dc351a.jpg";